export default class String {
  static replace (needle, replace, haystack) {
    const regExp = new RegExp(needle, 'g')
    const h = haystack + ''

    return h.replace(regExp, replace)
  }
}
